import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@core/i18n-legacy';
import type { DialogComponentI } from '@core/user-interface-legacy';
import {
  ButtonComponent,
  CheckboxComponent,
  DialogBodyComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
  DialogRef,
  IconComponent,
} from '@core/user-interface-legacy';

export interface ConfirmDialogResult {
  dontAskAgain: boolean;
  confirmed: boolean;
}

@Component({
  selector: 'rt-confirm-reveal-dialog',
  template: `
    <rt-dialog-header>
      <span class="heading">
        {{ 'app.candidate.anonymization.reveal_confirm_dialog.heading' | translate }}
      </span>
    </rt-dialog-header>
    <rt-dialog-body>
      <div layout-vertical>
        <p text-weight-semi-bold>
          {{ 'app.candidate.anonymization.reveal_confirm_dialog.message_p1' | translate }}
        </p>
        <p>{{ 'app.candidate.anonymization.reveal_confirm_dialog.message_p2' | translate }}</p>
        <ul>
          <li>{{ 'app.candidate.anonymization.reveal_confirm_dialog.list_item_1' | translate }}</li>
          <li>
            {{ 'app.candidate.anonymization.reveal_confirm_dialog.list_item_2_v2' | translate }}
          </li>
        </ul>
        <rt-checkbox
          [formControl]="dontAskAgainControl"
          data-cy="confirm-reveal-dialog:dont-ask-again-checkbox"
        >
          {{ 'app.candidate.anonymization.reveal_confirm_dialog.dont_ask_again' | translate }}
        </rt-checkbox>
      </div>
    </rt-dialog-body>
    <rt-dialog-footer innerPadding="small">
      <div layout>
        <rt-button variant="plain" (click)="cancel()">
          {{ 'app.common.cancel' | translate }}
        </rt-button>
        <rt-button
          variant="warning"
          (click)="confirm()"
          data-cy="confirm-reveal-dialog:confirm-button"
        >
          <rt-icon name="visibility" prefix />
          {{ 'app.candidate.anonymization.reveal_for_me' | translate }}
        </rt-button>
      </div>
    </rt-dialog-footer>
  `,
  styleUrls: ['./confirm-reveal-dialog.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DialogHeaderComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    TranslatePipe,
    CheckboxComponent,
    ReactiveFormsModule,
    ButtonComponent,
    IconComponent,
  ],
  host: {
    '[class.warning]': 'true',
  },
})
export class ConfirmRevealDialogComponent implements DialogComponentI<
  null,
  ConfirmDialogResult | undefined
> {
  private readonly dialogRef = inject(DialogRef);

  public dontAskAgainControl = new FormControl<boolean>(false);

  public setDialogData(data: null, triggerUpdate: boolean): void {
    return;
  }

  public cancel(): void {
    this.dialogRef.close({
      dontAskAgain: false,
      confirmed: false,
    });
  }

  public confirm(): void {
    this.dialogRef.close({
      dontAskAgain: this.dontAskAgainControl.value,
      confirmed: true,
    });
  }
}
